import { shoppingApi } from 'app/src/services/welfareportal'
import { getValueFromTypology } from 'app/src/shared/helpers'
import { useTranslation } from 'react-i18next'

export function DiscountRightPanelSide(props: {
  order: shoppingApi.OrderDetails
  showFringeSpinner?: boolean
  showCredit?: boolean
}) {
  const { t: tProductDetail } = useTranslation('productDetail')

  const getDiscountLabel = (discountType?: string): string => {
    if (discountType === 'percentage') {
      return tProductDetail('ProductDetail.discount.percentage')
    } else if (discountType === 'fixed') {
      return tProductDetail('ProductDetail.discount.fixed')
    }
    return tProductDetail('ProductDetail.discount.generic')
  }

  const discountType = props.order.variant?.priceDetails?.discountType
  const discountValue = props.order.variant?.priceDetails?.discountValue

  return (
    <div className={'col-span-12 lg:col-span-6'}>
      <div className='ml-[15px] mt-4 pl-12 lg:col-span-6 lg:ml-[30px] lg:mt-0 lg:pl-0'>
        {props.order.variant?.priceDetails && (
          <>
            <div className='h-[28px]'>{getDiscountLabel(discountType)}</div>
            <div className='mt-4 break-words text-2xl font-bold'>
              {discountValue ? getValueFromTypology(discountType, discountValue) : '-'}
            </div>
          </>
        )}
      </div>
    </div>
  )
}
